export const canaryKeys = {
  all: ['canary'] as const,
  me: () => [...canaryKeys.all, 'me'] as const,
  stats: () => [...canaryKeys.all, 'admin', 'stats'] as const,
  notes: () => [...canaryKeys.all, 'notes'] as const,
  noteList: (params: object) => [...canaryKeys.notes(), 'list', params] as const,
  note: (id: string) => [...canaryKeys.notes(), 'detail', id] as const,
  tasks: () => [...canaryKeys.all, 'tasks'] as const,
  taskList: (params: object) => [...canaryKeys.tasks(), 'list', params] as const,
  taskSummary: (today: string) => [...canaryKeys.tasks(), 'summary', today] as const,
  stressRuns: () => [...canaryKeys.all, 'stressRuns'] as const,
  stressRunList: (limit: number) => [...canaryKeys.stressRuns(), 'list', limit] as const,
};
